import { render, staticRenderFns } from "./ajax-select.vue?vue&type=template&id=b5634052"
import script from "./ajax-select.vue?vue&type=script&lang=js"
export * from "./ajax-select.vue?vue&type=script&lang=js"
import style0 from "./ajax-select.vue?vue&type=style&index=0&id=b5634052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports